// Copyright (c) 2022 Siemens

/**
 * @module js/oPINRQuickComposerModulePrereq
 */
import _appCtxSvc from 'js/appCtxService';
import swaC from '@swac/container';
import localeService from 'js/localeService'
import opcenterInRuntimeConfService from "js/oPINRuntimeModule/opcenterInRuntimeConfService";
import oPINRQuickComposerService from 'js/oPINRQuickComposerModule/oPINRQuickComposerService';
import utilService from 'js/commonUtilsModule/utilService';
import apmRESTService from 'js/commonUtilsModule/apmRESTService';
import navigationService from 'js/navigationService';

const exports = {};
function changePrereqStatus(howMuch =0){
    let reqS = _appCtxSvc.getCtx("prereqState") || 0;
    reqS +=howMuch;
    _appCtxSvc.updateCtx("prereqState",reqS)
}

///oPINRQuickComposerSublocation Prerequisite
function checkFeatures(){
    const fList = _appCtxSvc.getCtx('FeaturesListNames');
    return (fList.indexOf("AssetPerformance") !== -1)
}
exports.oPINRQuickComposerSublocationPrereq = function () {
    if (!checkFeatures()){
        //momUtils.navigateTo("missingPage",null)
        alert("AssetPerformance feature not available")
        return Promise.reject("AssetPerformance feature not available")
    }
    console.debug("###Prereq Enter oPINRQuickComposerSublocationPrereq")
    
    oPINRQuickComposerService.clearSizeObj()
    changePrereqStatus(1)
    const pList = [];
    pList.push(exports.initTradConf());
    _appCtxSvc.updateCtx("monitorSectionsList",new Set());
    _appCtxSvc.updateCtx("composerHistory",[]);
    pList.push(moveTimeFrameToCtx().then(res => { 
        buildvalipPageTemplate()
    }));
    const SWAC = new swaC();
    SWAC.Services.register('OPCINConfService', opcenterInRuntimeConfService, {
        delegable: true
    });
    return Promise.all(pList).then(x =>{
        _appCtxSvc.updateCtx("EditorMode","layout");
        changePrereqStatus(-1);
        console.debug("###Prereq Exit oPINRQuickComposerSublocationPrereq");        
    })
}

function moveTimeFrameToCtx() {
    const opTF = _appCtxSvc.getCtx("OpcenterDashboardbComposerTimeframes")
    const dopTF = _appCtxSvc.getCtx("defaultOpcenterDashboardbComposerTimeframes")
    if (opTF === null || opTF === undefined || dopTF === null || dopTF === undefined) {
        const TT = {
            "Previous_minute": "commonUtilsMessages",
            "Previous_minuteD": "commonUtilsMessages",
            "This_minute": "commonUtilsMessages",
            "This_minuteD": "commonUtilsMessages",
            "Minute_to_now": "commonUtilsMessages",
            "Minute_to_nowD": "commonUtilsMessages",
            "Last_minute": "commonUtilsMessages",
            "Last_minuteD": "commonUtilsMessages",
            "Previous_hour": "commonUtilsMessages",
            "Previous_hourD": "commonUtilsMessages",
            "This_hour": "commonUtilsMessages",
            "This_hourD": "commonUtilsMessages",
            "Hour_to_now": "commonUtilsMessages",
            "Hour_to_nowD": "commonUtilsMessages",
            "Last_hour": "commonUtilsMessages",
            "Last_hourD": "commonUtilsMessages",
            "Previous_day": "commonUtilsMessages",
            "Previous_dayD": "commonUtilsMessages",
            "This_day": "commonUtilsMessages",
            "This_dayD": "commonUtilsMessages",
            "Day_to_now": "commonUtilsMessages",
            "Day_to_nowD": "commonUtilsMessages",
            "Last_day": "commonUtilsMessages",
            "Last_dayD": "commonUtilsMessages",
            "Previous_week": "commonUtilsMessages",
            "Previous_weekD": "commonUtilsMessages",
            "This_week": "commonUtilsMessages",
            "This_weekD": "commonUtilsMessages",
            "Week_to_now": "commonUtilsMessages",
            "Week_to_nowD": "commonUtilsMessages",
            "Last_week": "commonUtilsMessages",
            "Last_weekD": "commonUtilsMessages",
            "This_shift": "commonUtilsMessages",
            "This_shiftD": "commonUtilsMessages",
            "Shift_to_now": "commonUtilsMessages",
            "Shift_to_nowD": "commonUtilsMessages",
            "This_workDay": "commonUtilsMessages",
            "This_workDayD": "commonUtilsMessages",
            "WorkDay_to_now": "commonUtilsMessages",
            "WorkDay_to_nowD": "commonUtilsMessages",
            "This_workWeek": "commonUtilsMessages",
            "This_workWeekD": "commonUtilsMessages",
            "WorkWeek_to_now": "commonUtilsMessages",
            "WorkWeek_to_nowD": "commonUtilsMessages"
        };
        let TTTrad = Object.getOwnPropertyNames(TT).map(x => {
            return localeService.getLocalizedText(TT[x], x)
        });
        const tf = [{
                "name": "Previous_minute",
                "description": "Previous_minuteD",
                "tfId": "previousMinute",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_minute",
                "description": "This_minuteD",
                "tfId": "thisMinute",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "thisID",
                "lastN": 1
            }, {
                "name": "Minute_to_now",
                "description": "Minute_to_nowD",
                "tfId": "minuteToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_minute",
                "description": "Last_minuteD",
                "tfId": "last1Minute",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "minutesID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "Previous_hour",
                "description": "Previous_hourD",
                "tfId": "previousHour",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_hour",
                "description": "This_hourD",
                "tfId": "thisHour",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Hour_to_now",
                "description": "Hour_to_nowD",
                "tfId": "hourToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_hour",
                "description": "Last_hour",
                "tfId": "last1Hour",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "hoursID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "Previous_day",
                "description": "Previous_dayD",
                "tfId": "previousDay",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_day",
                "description": "This_dayD",
                "tfId": "thisDay",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Day_to_now",
                "description": "Day_to_nowD",
                "tfId": "dayToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_day",
                "description": "Last_dayD",
                "tfId": "last1Day",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "daysID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "Previous_week",
                "description": "Previous_weekD",
                "tfId": "previousWeek",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "previousID",
                "lastN": 1
            },
            {
                "name": "This_week",
                "description": "This_weekD",
                "tfId": "thisWeek",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Week_to_now",
                "description": "Week_to_nowD",
                "tfId": "weekToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "Last_week",
                "description": "Last_weekD",
                "tfId": "last1Week",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "weeksID",
                "periodMode": "lastNID",
                "lastN": 1
            },
            {
                "name": "This_shift",
                "description": "This_shiftD",
                "tfId": "thisWorkShift",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workShiftsID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "Shift_to_now",
                "description": "Shift_to_nowD",
                "tfId": "workShiftToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workShiftsID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "This_workDay",
                "description": "This_workDayD",
                "tfId": "thisWorkDay",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workDaysID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "WorkDay_to_now",
                "description": "WorkDay_to_nowD",
                "tfId": "workDayToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workDaysID",
                "periodMode": "toNowID",
                "lastN": 1
            },
            {
                "name": "This_workWeek",
                "description": "This_workWeekD",
                "tfId": "thisWorkWeek",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workWeeksID",
                "periodMode": "thisID",
                "lastN": 1
            },
            {
                "name": "WorkWeek_to_now",
                "description": "WorkWeek_to_nowD",
                "tfId": "workWeekToNow",
                "tfMode": false,
                "custom": false,
                "endDateTimeDetails": 1571036400000,
                "startDateTimeDetails": 1571034600000,
                "tfUoT": "workWeeksID",
                "periodMode": "toNowID",
                "lastN": 1
            }
        ]
        return Promise.all(TTTrad).then(tradArray => {
            let pName = Object.getOwnPropertyNames(TT);
            Object.getOwnPropertyNames(TT).forEach((x, index) => {
                TT[x] = tradArray[pName.indexOf(x)]
            });
            const tfT = tf.map(tf => {
                tf.name = TT[tf.name];
                tf.description = TT[tf.description];
                return tf;
            })
            _appCtxSvc.updateCtx("OpcenterDashboardbComposerTimeframes", tfT);
            _appCtxSvc.updateCtx("defaultOpcenterDashboardbComposerTimeframes", JSON.parse(JSON.stringify(tfT)));
        })
    }
    return Promise.resolve();
}

function buildvalipPageTemplate() {
    const composerEmptyPage = _appCtxSvc.getCtx("composerEmptyPage");
    if (composerEmptyPage === null || composerEmptyPage === undefined) {
        var Page = {
            'composerVer': oPINRQuickComposerService.qcDashboardVersion,
            'root': {},
            'timeframes': []
        };
        Page.timeframes = _appCtxSvc.getCtx("OpcenterDashboardbComposerTimeframes");;
        var pageBlob = JSON.stringify(Page);
        _appCtxSvc.updateCtx("composerEmptyPage", pageBlob)
        return Promise.resolve({
            data: pageBlob
        });
    }
    return Promise.resolve(composerEmptyPage);
}

exports.initTradConf = function() {
    const commonTrad = _appCtxSvc.getCtx("commonTrad");
    if (commonTrad === null || commonTrad === undefined) {

        const TT = {
            "BAD": "commonUtilsMessages",
            "UNCERTAIN": "commonUtilsMessages",
            "Unknown": "commonUtilsMessages",
            "GOOD": "commonUtilsMessages",
            "Counter": "commonUtilsMessages",
            "Cycletime": "commonUtilsMessages",
            "Speed": "commonUtilsMessages",
            "noData": "oPINRQuickComposerMessage",
            "delta": "oPINRQuickComposerMessage",
            "incremental": "oPINRQuickComposerMessage",
            "kpiDiv0": "oPINRQuickComposerMessage",
            "kpiError": "oPINRQuickComposerMessage",
            "kpiNoData": "oPINRQuickComposerMessage",
            "kpiNoAsset": "oPINRQuickComposerMessage",
            "kpiNoTF": "oPINRQuickComposerMessage",
            "YES": "commonUtilsMessages",
            "NO": "commonUtilsMessages"
        };
        let TTTrad = Object.getOwnPropertyNames(TT).map(x => {
            return localeService.getLocalizedText(TT[x], x)
        });
        return Promise.all(TTTrad).then(tradArray => {
            let pName = Object.getOwnPropertyNames(TT);
            Object.getOwnPropertyNames(TT).forEach((x, index) => {
                TT[x] = tradArray[pName.indexOf(x)]
            });
            const res = {
                "tradQuality": [
                    TT["BAD"],
                    TT["UNCERTAIN"],
                    TT["Unknown"],
                    TT["GOOD"]
                ],
                "tradQuality_OPC_UA": [TT["GOOD"], TT["UNCERTAIN"], TT["BAD"], TT["BAD"]],
                "tradMetricCategory": {
                    "Counter": TT["Counter"],
                    "Cycletime": TT["Cycletime"],
                    "Speed": TT["Speed"]
                },
                "noDataGaugeLbl": TT["noData"],
                "samplingModeString": [TT["delta"], TT["incremental"]],
                "noDataTrad": TT["noData"],
                "errorStr": {
                    "div0": TT["kpiDiv0"],
                    "error": TT["kpiError"],
                    "nodata": TT["kpiNoData"],
                    "kpiNoAsset": TT["kpiNoAsset"],
                    "kpiNoTF": TT["kpiNoTF"]
                },
                "generic": {
                    "yes": TT["YES"],
                    "no": TT["NO"]
                }
            }
            _appCtxSvc.updateCtx("commonTrad", res);
        });
    }
    return Promise.resolve();
}

exports.oPINRQuickComposerEditorPrereq= function () {
    console.debug("###Prereq Enter oPINRQuickComposerEditorPrereq")
    _appCtxSvc.updateCtx("momPrimaryToolbarSearchEnabledHasCommands",false)
    changePrereqStatus(1)
    const theCC = _appCtxSvc.getCtx("oPINProjectsConfig");
    const state = _appCtxSvc.getCtx("state");
    let MPDashboardContributor = theCC.oPINRuntime.MPDashboardContributor;

    const chekQCE = theCC.hasOwnProperty("enableQCEditor") ?theCC.enableQCEditor:true;
    if (!chekQCE){
        //crack group
        MPDashboardContributor = MPDashboardContributor+"REACTMIGRATIONDISABLE"
    }

    let p1 = oPINRQuickComposerService.cleanPageCtx();
    p1 = p1.then(res => utilService.checkPageAccess(MPDashboardContributor));
    p1.then(x => {
        _appCtxSvc.updateCtx("LastEngQCD",state.params.dashboardid);
    })
    let realP = [
        "GET",
        theCC.oPINRuntime.apiDSComposer+'opdashboard/source/'+state.params.dashboardid,
        {
            "withCredentials": false,
            "addVersion": false
        },
        {
            "logInfo": "loadTimeCategoryTableData",
            "confList": {
                "propDisplayValue": "Name",
                "propDisplayDescription": "Description",
                "dispValue": "Name",
                "propInternalValue": "id"
            },
            "preOutputDataFilter": [{
                "method": "activateDashboard2",
                "deps": "js/mpEditor/mpComposerService"
            }]
        }
    ]
    p1 = p1.then(res => oPINRQuickComposerService.openDSSource(...realP));

    _appCtxSvc.updateCtx("loaded",false)
    const currentRuntimegPrj = _appCtxSvc.getCtx("currentRuntimegPrj");
    let p2 = Promise.resolve()
    if (currentRuntimegPrj === null || currentRuntimegPrj === undefined){
        const apiProject = _appCtxSvc.getCtx("oPINProjectsConfig").oPINRuntime.api;
        //"ctx.oPINProjectsConfig.oPINEngineering.apiProject + 'projects/' + stateParams.engprojectid"
        var projectK = _appCtxSvc.getCtx("state").processed.engprojectid;
        //p2 = utilService.OCINRESTService("get",apiProject+ 'runtime/projects/').then(p =>{
        p2 = apmRESTService.OCINRESTServiceValidated("get",apiProject+ 'runtime/projects/').then(p =>{
            _appCtxSvc.updateCtx("currentRuntimegPrj",p.data.search[0])
        })
    }

    return Promise.all([p1,p2]).then(x => {
        _appCtxSvc.updateCtx("LastEngQCD",state.params.dashboardid);
        console.debug("###Prereq Exit oPINRQuickComposerEditorPrereq")
        changePrereqStatus(-1);
    })
}
exports.oPINRQuickComposerRuntimePrereq = function () {


    console.debug("###Prereq Enter oPINRQuickComposerRuntimePrereq")
    
    changePrereqStatus(1)
    const theCC = _appCtxSvc.getCtx("oPINProjectsConfig");
    const state = _appCtxSvc.getCtx("state");
    const MPDashboardViewers = [theCC.oPINRuntime.MPDashboardViewer,"RuntimeRestrictedAccess"];
    let p1 = oPINRQuickComposerService.cleanPageCtx();
    p1 = p1.then(res => utilService.checkPageAccess(MPDashboardViewers));
    p1.then(x => {
        _appCtxSvc.updateCtx("LastRunQCD",state.params.dashboardid);
    })
    let realP = [
        "GET",
        theCC.oPINRuntime.apiDSComposer+'opdashboard/published/'+state.params.dashboardid,
        {
            "withCredentials": false,
            "addVersion": false
        },
        {
            "logInfo": "loadTimeCategoryTableData",
            "confList": {
                "propDisplayValue": "Name",
                "propDisplayDescription": "Description",
                "dispValue": "Name",
                "propInternalValue": "id"
            },
            "preOutputDataFilter": [{
                "method": "activateDashboard2",
                "deps": "js/mpEditor/mpComposerService"
            }]
        }
    ]
    p1 = p1.then(res => oPINRQuickComposerService.openDSSource(...realP));

    const currentRuntimegPrj = _appCtxSvc.getCtx("currentRuntimegPrj");
    let p2 = Promise.resolve()
    if (currentRuntimegPrj === null || currentRuntimegPrj === undefined){
        const apiProject = _appCtxSvc.getCtx("oPINProjectsConfig").oPINRuntime.api;
        //"ctx.oPINProjectsConfig.oPINEngineering.apiProject + 'projects/' + stateParams.engprojectid"
        var projectK = _appCtxSvc.getCtx("state").processed.engprojectid;
        
        //p2 = utilService.OCINRESTService("get",apiProject+ 'runtime/projects/').then(p =>{
        p2 = apmRESTService.OCINRESTServiceValidated("get",apiProject+ 'runtime/projects/').then(p =>{
            _appCtxSvc.updateCtx("currentRuntimegPrj",p.data.search[0])
        })
    }
    _appCtxSvc.updateCtx("loaded",false)
    return Promise.all([p1,p2]).then(x => {
        _appCtxSvc.updateCtx("LastRunQCD",state.params.dashboardid);
        var associatedUsers = _appCtxSvc.getCtx("currentDashboardInfo").AssociatedUsers.map(name => name.toLowerCase());
        var userFullName = _appCtxSvc.getCtx("cognitoToken").accessToken.payload.username.toLowerCase(); // _appCtxSvc.getCtx("user").fullName;
        
        if (associatedUsers.indexOf(userFullName) === -1){
            //Not authorized
            utilService.goToError(true, null);
             
            throw new Error('You are not authorized to view this dashboard');
        }
        
        console.debug("###Prereq Exit oPINRQuickComposerRuntimePrereq")
        changePrereqStatus(-1);
    })
}

export default exports;